import * as Website from '../Config/Website.js';

const responsiveVideo = () => {
  const videos = document.querySelectorAll(".js-kvVideo");
  
  // ビデオソースを更新
  function updateVideoSources(video, baseSrc, isMobile) {
    const suffix = isMobile ? "_sp" : "_pc";
    const sourceMP4 = createSourceElement(baseSrc + suffix + ".mp4", "video/mp4");
    
    video.innerHTML = "";
    video.appendChild(sourceMP4);
    video.load();
  }
  
  function createSourceElement(src, type) {
    const source = document.createElement("source");
    source.setAttribute("src", src);
    source.setAttribute("type", type);
    return source;
  }
  
  // すべての動画を更新
  function updateAllVideos(isMobile) {
    // console.log(`動画を更新: ${isMobile ? 'モバイル' : 'デスクトップ'}`);
    videos.forEach((video) => {
      const baseSrc = video.getAttribute("data-src");
      updateVideoSources(video, baseSrc, isMobile);
    });
  }
  
  // メディアクエリを作成
  const mediaQuery = window.matchMedia(`(max-width: ${Website.options.breakpoint.sp - 1}px)`);
  
  // 初回読み込み
  updateAllVideos(mediaQuery.matches);
  
  // メディアクエリの変更を監視（ブレークポイントを跨いだ時のみ発火）
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', (e) => {
      updateAllVideos(e.matches);
    });
  }
};

const init = () => {
  responsiveVideo();
};

export default init;